// Import bootstrap
import * as bootstrap from 'bootstrap'

// Import our SCSS
import '../scss/main.scss'

// Your custom JavaScript here

// Update URL hash when a Bootstrap tab is activated
document.addEventListener('DOMContentLoaded', function () {
	const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
	tabLinks.forEach(function (tab) {
		tab.addEventListener('shown.bs.tab', function (event) {
			if (event.target && event.target.id) {
				// Update the hash in the URL bar
				history.replaceState(null, '', '#' + event.target.id);
			}
		});
	});
});